import React from 'react';
import { Grid, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const HeaderRowButton = props => {
  const { headerRowButtons, headerInfo, setHeaderRowButtonState } = props;

  return (
    <Grid.Column width={12}>
      <Button.Group basic className="btn-group--active-group">
        {headerRowButtons.map(button => (
          <Button
            key={button.title}
            basic
            className="white"
            active={headerInfo === button.value}
            onClick={() => setHeaderRowButtonState(button.value)}
          >
            {button.title}
          </Button>
        ))}
      </Button.Group>
    </Grid.Column>
  );
};

HeaderRowButton.propTypes = {
  headerRowButtons: PropTypes.array.isRequired,
  headerInfo: PropTypes.string.isRequired,
  setHeaderRowButtonState: PropTypes.func.isRequired,
};

export default HeaderRowButton;



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/components/HeaderRowButton.js